import Icon from 'veui/components/Icon'
import { IconDownload } from 'dls-icons-vue'

Icon.register('download', IconDownload)
